import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Route prefixes where the Numeo extension's floating overlays must be hidden. Box Truck reuses the LoadHub
// loadboard's full-bleed layout, which the sticky button overlaps — and box-truck pages don't render LoadHub's
// own hide-effect, so they need it here. `startsWith` covers all four box-truck routes with one entry.
const HIDE_ON_ROUTES = ['/dispatcher/box-truck-']

// Floating overlays the Numeo extension injects into the admin document (content script).
const EXT_STICKY_SELECTORS = ['#ext-loadops-sticky-ui', '#ext-loadops-private-loads-button', '#numeo-loadops-sticky-ui']

const STYLE_ID = 'numeo-hide-ext-loadops-sticky'

/**
 * Single source of truth for hiding the Numeo extension's floating "LoadOps" sticky button (and siblings). A
 * CSS rule is injected rather than mutating the element directly because the extension adds the button
 * ASYNCHRONOUSLY and may re-inject it — a rule keeps it hidden regardless of timing, and removing the rule
 * restores it. Mirrors the route-driven suppression useIntercom applies to the Intercom launcher.
 *
 * @param active When provided, the CALLER controls visibility (e.g. load-hub / agentic-hub hide it while their
 *   page is mounted). When omitted, it falls back to the route check (box-truck routes) — for the single
 *   AppRoutes mount. All three surfaces share this one mechanism instead of each rolling their own.
 */
export function useHideExtLoadopsSticky(active?: boolean) {
    const location = useLocation()
    const shouldHide = active ?? HIDE_ON_ROUTES.some((route) => location.pathname.startsWith(route))

    useEffect(() => {
        if (!shouldHide) return
        const style = document.createElement('style')
        style.id = STYLE_ID
        style.textContent = `${EXT_STICKY_SELECTORS.join(', ')} { display: none !important; }`
        document.head.appendChild(style)
        return () => style.remove()
    }, [shouldHide])
}
